import { render, staticRenderFns } from "./ShopPage.vue?vue&type=template&id=abc3f2ae&scoped=true&"
import script from "./ShopPage.vue?vue&type=script&lang=js&"
export * from "./ShopPage.vue?vue&type=script&lang=js&"
import style0 from "./ShopPage.vue?vue&type=style&index=0&id=abc3f2ae&lang=scss&scoped=true&"
import style1 from "./ShopPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc3f2ae",
  null
  
)

export default component.exports